import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { DataGrid } from '@mui/x-data-grid';

import { startJob, fetchConfirmedJobs } from './action';
import { selectConfirmedJobs, selectUpdateJobError } from './selector';
import { selectUser } from '../Auth/selector';

const ConfirmedJobList = () => {
  const dispatch = useDispatch();
  const authenticatedUser = useSelector(selectUser);
  const confirmedJobs = useSelector(selectConfirmedJobs);
  const updateJobError = useSelector(selectUpdateJobError);

  const [selectedJob, setSelectedJob] = useState(null);

  useEffect(() => {
    dispatch(fetchConfirmedJobs(authenticatedUser));
  }, [dispatch, authenticatedUser]);

  const petTypes = [
    { label: 'Cat', value: 'cat' },
    { label: 'Dog', value: 'dog' },
  ];

  const onStartJob = (job) => {
    setSelectedJob(job);
  };

  const handleCloseDialog = () => {
    setSelectedJob(null);
  };

  const handleStartJob = () => {
    dispatch(startJob(selectedJob));
    setSelectedJob(null);
  };

  const columns = [
    { field: '_id', sortable: false, headerName: 'Job ID', width: 220 },
    {
      field: 'createdAt',
      headerName: 'Created on',
      width: 150,
      valueGetter: (params) => {
        const date = new Date(params.value);
        return date.toLocaleDateString('en-US');
      }
    },
    {
      field: 'petName',
      headerName: 'Pet Name',
      width: 150,
      valueGetter: (params) => params.row.jobDetails.petName,
    },
    {
      field: 'petType',
      headerName: 'Pet Type',
      width: 150,
      valueGetter: (params) => {
        const { petType } = params.row.jobDetails;
        return petTypes.find(pet => pet.value === petType)?.label;
      },
    },
    {
      field: 'action',
      headerName: 'Action',
      width: 150,
      isableClickEventBubbling: true,
      sortable: false,
      renderCell: (params) => (
        <Button variant="text" onClick={() => onStartJob(params.row)}>
          Start
        </Button>
      ),
    },
  ];

  return (
    <Container component="main" maxWidth="md" sx={{ pt: 6 }}>
      <Dialog
        maxWidth="xs"
        open={selectedJob !== null}
      >
        <DialogTitle sx={{ pb: 3.5 }}>Confirmation</DialogTitle>
        <DialogContent>
          Please confirm if you want to start the job.
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button autoFocus onClick={handleCloseDialog}>No</Button>
          <Button onClick={handleStartJob}>Yes</Button>
        </DialogActions>
      </Dialog>
      <Typography variant="h5" component="h1">
        Total Confirmed Jobs: {confirmedJobs.length}
      </Typography>
      {updateJobError && (
        <Alert severity="error" sx={{ mt: 1 }}>{updateJobError}</Alert>
      )}
      <div
        style={{
          height: 80 * confirmedJobs.length + 200,
          width: '100%',
          marginTop: 20,
        }}
      >
        <DataGrid
          rows={confirmedJobs}
          columns={columns}
          getRowId={row => row._id}
          pageSize={10}
          rowsPerPageOptions={[10]}
        />
      </div>
    </Container>
  );
};

export default ConfirmedJobList;
